// Mis negocios: para el implementador que atiende varios, el gateway de cada uno en una fila — cuánto gasta, si
// algo dejó de responder — sin abrirlos uno por uno.
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { Badge, Cargando, PageHead, Tabla } from '@glubi/ds';
import { api } from '../lib/api';
import { desde, numero, usd } from '../lib/formato';
import { useSesion } from '../lib/sesion';

const ROL: Record<string, string> = { administrador: 'Administrador', implementador: 'Implementador', administracion: 'Administración' };

export function Negocios() {
  const { elegirCuenta } = useSesion();
  const navegar = useNavigate();
  const q = useQuery({ queryKey: ['negocios'], queryFn: () => api<any[]>('/api/negocios'), refetchInterval: 120_000 });
  if (q.isLoading) return <Cargando />;
  return (
    <div className="page">
      <PageHead title="Mis negocios" subtitle="El gateway de cada negocio que atiendes. Clic en uno para entrar." />
      <Tabla rowKey="cuentaId" rows={q.data ?? []} onRowClick={(n: any) => { elegirCuenta(n.cuentaId); void navegar({ to: '/resumen' }); }}
        columns={[
          { key: 'negocio', label: 'Negocio', render: (n: any) => <div><b style={{ fontWeight: 500 }}>{n.negocio}</b><div className="muted" style={{ fontSize: 12 }}>{ROL[n.rol] ?? n.rol}{n.puedeAdministrar ? '' : ' · solo ver'}</div></div> },
          { key: 'gasto', label: 'Gasto del mes', numeric: true, render: (n: any) => <span>{usd(n.gasto_mes)}{n.presupuesto_mes !== null && <span className="muted"> / {usd(n.presupuesto_mes)}</span>}</span> },
          { key: 'llamadas_7d', label: 'Llamadas 7 días', numeric: true, render: (n: any) => numero(n.llamadas_7d) },
          { key: 'fallidas_7d', label: 'Fallidas', numeric: true, render: (n: any) => (n.fallidas_7d ? <Badge state="error">{numero(n.fallidas_7d)}</Badge> : <span className="muted">—</span>) },
          { key: 'conectado', label: 'Conectado', render: (n: any) => `${n.modelos} modelos · ${n.conectores} conectores · ${n.llaves} llaves` },
          { key: 'salud', label: 'Conectores', render: (n: any) => (n.conectores_con_error ? <Badge state="error">{n.conectores_con_error} sin responder</Badge> : n.conectores ? <Badge state="ok">Bien</Badge> : <span className="muted">—</span>) },
          { key: 'ultima_llamada', label: 'Última llamada', render: (n: any) => desde(n.ultima_llamada) },
        ]} />
    </div>
  );
}
